import * as React from "react"


export default function userColumn() {
    return {
		name: 'username',
		label: 'User',
		options: {
			setCellProps: () => ({ sx: { textAlign: "center" } })
		}
	}
}